import { Box, Heading, Text } from '@chakra-ui/react';

import { Card } from '~/components/card';
import { Glyph } from '~/components/glyph';
import { useI18n } from '~/hooks/use-i18n';

export function CatalogNoResults() {
  const { t, isTranslated } = useI18n();

  return (
    <Card
      alignItems='center'
      borderColor='accent.sky.500'
      display='flex'
      flexDirection='column'
      padding='40px'
      textAlign='center'
    >
      <Glyph name='browser-binary-magnifying-glass-one' />
      <Box h='16px' />
      <Heading as='h2' size='h4'>
        {t('catalog.noResults.heading')}
      </Heading>
      <Box h='8px' />
      {isTranslated ? (
        <Text fontSize='sm'>{t('catalog.noResults.translatedBody')}</Text>
      ) : (
        <Text>{t('catalog.noResults.body')}</Text>
      )}
    </Card>
  );
}
